import styled from '@emotion/styled'

export const Container = styled('div')<{ visible: boolean }>`
  width: 100%;
  padding: 40px;
  overflow: hidden;
  position: relative;
  display: ${(props) => (props.visible ? 'block' : 'none')};
`
